import React from 'react';
import { Outlet } from 'react-router-dom';

const Settings: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-gray-900">Settings</h1>
      </div>
      <Outlet />
    </div>
  );
};

export default Settings; 